export default __webpack_public_path__ + "static/media/processo.eb97d38b.png";